import { Alert, Box } from '@mui/material';
import { useAuthFormsContext } from '../../../contexts/AuthFormsContext';
import useLocalization from '../../../hooks/useLocalization';
import { CASINO_SIGN_IN_STYLES } from '../../../styles/components/casinoSignIn';

const CasinoSignInScreen = () => {
  const { LoginForm } = useAuthFormsContext();
  const { t } = useLocalization();

  return (
    <Box sx={CASINO_SIGN_IN_STYLES.screen} data-testid='casino-sign-in-screen'>
      <Box sx={CASINO_SIGN_IN_STYLES.form}>
        {LoginForm ? (
          <LoginForm presentation='embedded' />
        ) : (
          <Alert severity='warning'>{t('casinoSignInUnavailable')}</Alert>
        )}
      </Box>
    </Box>
  );
};

export default CasinoSignInScreen;
